// FLAGS: none
// Maps an i18next language onto a date-fns locale object, for the app-wide `setDefaultOptions` call
// and for callers that format a date in a language they were handed rather than the active one.
import { enGB, nl, de, es, fr } from "date-fns/locale";
import i18n from "@src/i18n";

/**
 * Defaults to the active language, which is what the app-wide `setDefaultOptions` call wants. Pass a
 * language explicitly to format in one other than the active one. The default follows every in-place
 * switch, re-applied by the boot's `languageChanged` subscription.
 */
const DateFnslocaleMapper = (language: string = i18n.language) => {
  switch (language) {
    case "nl":
    case "nl-NL":
      return nl;
    case "en":
    case "en-GB":
    case "en-US":
      return enGB;
    case "de":
    case "de-DE":
      return de;
    case "fr":
    case "fr-FR":
      return fr;
    case "es":
    case "es-ES":
      return es;
    default:
      return nl;
  }
};

export { DateFnslocaleMapper };
